<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px;" >
      <el-col :span="24">
        <el-button class="btn" type="primary" @click="addTenantHandle" icon="el-icon-plus">增加</el-button>
        <!-- <el-button class="btn" type="primary" @click="updateTenant" icon="el-icon-edit">修改</el-button> -->
      </el-col>
    </el-row>
    <el-row style="margin-top:15px;">
      <el-col :span="24">
        <el-table :data="tableData" ref="deviceTable" id="deviceTable"
          :header-cell-style="{ background: '#eff3f6' }" stripe :row-key="getRowKeys">
          <el-table-column prop="tenantName" label="租户名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="account" label="登录账号" width="200">
          </el-table-column>
          <el-table-column prop="contactName" label="联系人"  width="160">
          </el-table-column>
          <el-table-column prop="phone" label="联系电话"  width="200">
          </el-table-column>
          <el-table-column prop="status" label="状态" width="160">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 1" size="mini" type="success">正常</el-tag>
              <el-tag v-else size="mini" type="danger">停用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :formatter="formateTime" label="录入日期" width="160">
          </el-table-column>
          <el-table-column sortable label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button  @click="updateTenantHandle(scope.row)" type="text"
                size="small">修改
              </el-button>
              <el-button @click="start(scope.row, 1)" v-if="scope.row.status == '0'" style="color: green;" type="text" size="small">启用
              </el-button>
              <el-button @click="start(scope.row, 0)" type="text" v-if="scope.row.status == '1'" style="color: red;"
                size="small">停用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination v-if="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </el-row>

    <!----------添加----------->
    <el-dialog :visible.sync="dialogVisible" title="增加租户" :close-on-click-modal="false" :close-on-press-escape="false"
      style="width: 60% !important; margin-left: 400px">
      <el-form :model="questionForm" ref="questionForm" :rules="rules" label-position="left" label-width="100px"
        style="width: 80%; margin-left: 10%">
        <el-form-item label="租户名称" prop="tenantName">
          <el-input placeholder="请输入租户名称" v-model.trim="questionForm.tenantName" />
        </el-form-item>
        <el-form-item label="联系人" prop="contactName">
          <el-input placeholder="请输入联系人" v-model.trim="questionForm.contactName" />
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input placeholder="请输入联系电话" v-model.trim="questionForm.phone" />
        </el-form-item>
        <el-form-item label="登录账号" prop="account">
          <el-input placeholder="请输入登录账号" v-model.trim="questionForm.account" />
        </el-form-item>
        <el-form-item label="登录密码" prop="passwd">
          <el-input placeholder="请输入登录密码" v-model.trim="questionForm.passwd" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTenantOk" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>

    <!---------修改------->
    <el-dialog :visible.sync="dialogVisible1" title="修改租户信息" :close-on-click-modal="false"
      :close-on-press-escape="false" style="width: 60% !important; margin-left: 400px">
      <el-form :model="questionForm" ref="questionForm" :rules="updateRules" label-position="left" label-width="100px"
        style="width: 80%; margin-left: 10%">
        <el-form-item label="账户名称" prop="tenantName">
          <el-input placeholder="请输入租户名称" v-model.trim="questionForm.tenantName" />
        </el-form-item>
        <el-form-item label="联系人" prop="contactName">
          <el-input placeholder="请输入联系人" v-model.trim="questionForm.contactName" />
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input placeholder="请输入联系电话" v-model.trim="questionForm.phone" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="updateTenantOk" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectTenant,
  addTenant,
  updateTenant
} from "../../api/api";
export default {
  name: "Tenants",
  data() {
    var isMobileNumber = (rule, value, callback) => {
      if (!value) {
        return new Error("请输入电话号码");
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        const isPhone = reg.test(value);
        value = Number(value); //转换为数字
        if (typeof value === "number" && !isNaN(value)) {
          //判断是否为数字
          value = value.toString(); //转换成字符串
          if (value.length < 0 || value.length > 12 || !isPhone) {
            //判断是否为11位手机号
            callback(new Error("手机号码格式如:138xxxx8754"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入电话号码"));
        }
      }
    };
    return {
      deviceInfo: {
        content: "",
      },
      show: {
        zj: false,
        xg: false,
        sc: false,
        czmm: false,
        scPlus: false,
      },
      questionForm: {},
      userForm: {},
      form: {},
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      tableData: [],
      dialogVisible : false,
      dialogVisible1 : false,
      rules: {
        tenantName: [
          { required: true, message: "请输入账户名称", trigger: "blur" },
          {
            min: 3,
            max: 128,
            message: "长度在 3 到 128 个字符",
            trigger: "blur",
          },
        ],
        contactName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: isMobileNumber, trigger: "blur" },
        ],
        account: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
          {
            min: 4,
            max: 16,
            message: "长度在 2 到 16 个字符",
            trigger: "blur",
          },
        ],
        passwd: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            min: 8,
            max: 20,
            message: "长度在 8 到 20 个字符",
            trigger: "blur",
          },
        ]
      },
      updateRules: {
        tenantName: [
          { required: true, message: "请输入账户名称", trigger: "blur" },
          {
            min: 3,
            max: 128,
            message: "长度在 3 到 128 个字符",
            trigger: "blur",
          },
        ],
        contactName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: isMobileNumber, trigger: "blur" },
        ],
      }
    };
  },
  mounted() {
    this.selectTenant();
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
      this.selectTenant();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      sessionStorage.setItem("pageIndex", val);
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.selectTenant();
    },
    //查询所有租户
    selectTenant() {
      let _params = {
        pageIndex: this.pageIndex,
        pageSize: this.pagesize
      };
      selectTenant(_params).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.tableData = data.list;
          this.total = data.total;
        }
      });
    },
    start(row, type) {
      let op = '停用';
      if (type == 1) {
        op = '启用';
      }
      this.$confirm("确认是否"+op+"该租户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateTenant({status: type, id:row.id}).then((datas) => {
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error",
              });
            } else if (status == 200) {
              this.selectTenant();
              this.dialogVisible = false;
              this.$message({
                message: op + "成功",
                type: "success",
              });
              this.dialogVisible1 = false;
            } else {
              this.$message({
                message: "请求错误",
                type: "error",
              });
            }
          });
      });
    },
    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.createTime);
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, "0");
      let date = nowData.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${date}`;
    },
    addTenantHandle(){
      this.dialogVisible = true;
    },
    //添加账户
    addTenantOk() {
      this.$refs.questionForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认新增账户吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            addTenant(this.questionForm).then((datas) => {
              if(datas.status == 200){
                this.selectTenant();
                this.$message({
                  message: "增加成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }else{
                this.$message({
                    message: datas.message,
                    type: "error",
                });
              }
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    updateTenantHandle(row){
      this.questionForm = row;
      this.dialogVisible1 = true;
    },
    //修改用户信息
    updateTenantOk() {
      this.$refs.questionForm.validate((valid) => {
        if (valid) {
          updateTenant(this.questionForm).then((datas) => {
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error",
              });
            } else if (status == 200) {
              this.selectTenant();
              this.dialogVisible = false;
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.dialogVisible1 = false;
            } else {
              this.$message({
                message: "请求错误",
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

  },
};
</script>
<style>
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/tenants/Tenants.vue